class TimezonesListController implements ng.IComponentController {
    sortType: string;

    private weekDays = ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'];

    constructor() {
        'ngInject';

        this.sortType = 'from';
    }
}

export const timezonesListComponent: ng.IComponentOptions = {
    controller: TimezonesListController,
    bindings: {
        timezones:'<'
    },
    template: require('./timezones.list.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/settings/timezones/timezones.list.component.ts